import React from 'react';
import { useController, UseControllerProps } from 'react-hook-form';

import { Autocomplete, Box, CircularProgress, createFilterOptions, FormControl, TextField } from '@mui/material';
import { StaticDataModel } from '../../../Model/Dto/StaticData';

interface IProps extends UseControllerProps {
    label?: string;
    options: StaticDataModel[];
    size?: "small" | "medium";
    loading?: boolean;
    limit?: number;
    onChange?: (value: any) => void;
    onInputFieldChange?: (value: string) => void;
    useManualFiltering?: boolean;
}

const AppAutoComplete = (props: IProps) => {

    const filterOptions: any = createFilterOptions<any>({
        matchFrom: 'any',
        stringify: (option) => option.Name,
        limit: props.limit === undefined ? 20 : props.limit,
    });

    const { fieldState, field } = useController({ ...props, defaultValue: null });
    return (
        <FormControl fullWidth error={!!fieldState.error}>
            <Autocomplete
                {...props}
                {...field}
                onChange={(event, value) => {
                    field.onChange(value);
                    if (props.onChange) {
                        if (value != null) {
                            props.onChange(value);
                        }
                    }
                }}
                onInputChange={(event, newInputValue) => {
                    if (props.onInputFieldChange) {
                        if (newInputValue != null) {
                            props.onInputFieldChange(newInputValue);
                        }
                    }
                }}
                options={props.options}
                filterOptions={(options, { inputValue }) => {
                    if (props.useManualFiltering === true) {
                        return options;
                    } else {
                        return filterOptions(options, { inputValue }); 
                    }
                }}                
                getOptionLabel={option => option.Name}
                isOptionEqualToValue={(option, value) => option.Id === value.Id}
                loading={props.loading}
                renderOption={(props, option) => (
                    <Box component="li" {...props} key={option.Id}>
                        {option.Name}
                    </Box>
                )}
                renderInput={
                    (params) => <TextField
                        {...params}
                        fullWidth
                        label={props.label}
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <React.Fragment>
                                    {props.loading ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </React.Fragment>
                            ),
                        }}
                        variant="outlined"
                        size={props.size}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                    />
                }
            />
        </FormControl>
    )
}

export default AppAutoComplete